<template>
  <div class="preview box">
    <img :src="image" alt>

    <app-section
      v-for="(line, i) in lines"
      :key="`line-${i}`"
      :top="line.top"
      :left="line.left"
      :width="line.width"
      :height="line.height"
      :probability="line.conf"
      :value="line.text"
    ></app-section>
    
  </div>
</template>

<script>
import Section from "@/components/scan/ScanSection.vue";

export default {
  name: "scan-preview",
  components: {
    AppSection: Section
  },
  props: {
    image: String,
    lines: Array
  }
};
</script>


<style lang="scss" scoped>
.preview {
  position: relative;
  padding: 0;

  img {
    display: block;
    width: 100%;
    border-radius: 24px;
  }
}
</style>
